import React, { useMemo } from 'react';
import whats from '@/assets/images/whats.png';
import insta from '@/assets/images/insta.png';
import abrir from '@/assets/images/abrir.png';
import mapa from '@/assets/images/mapa.png';

import { waService } from '@/services/domain/WhatsAppService';

const useWhatsAppInfo = () => {
  return useMemo(() => {
    const defaultNumber = waService.getDefaultNumber();
    const formattedDisplay = waService.formatDisplayNumber(defaultNumber);

    try {
      const url = waService.buildUrl();
      return {
        display: formattedDisplay || defaultNumber,
        url,
      };
    } catch (error) {
      console.error('Número do WhatsApp não configurado corretamente.', error);
      return {
        display: formattedDisplay || 'WhatsApp não configurado',
        url: '#',
      };
    }
  }, []);
};

const ContatoPage: React.FC = () => {
  const whatsappInfo = useWhatsAppInfo();
  const whatsappHref = whatsappInfo.url === '#' ? undefined : whatsappInfo.url;

  return (
    <section id="contact" className="contact-section">
      <div className="container">
        {/* Hero de contato / CTA principal */}
        <div className="contact-cta">
          <div className="cta-content">
            <h3>Pronto para cuidar do seu felino?</h3>
            <p>Entre em contato conosco para agendar uma consulta, tirar dúvidas ou pedir produtos para o seu gato.</p>
            <div className="cta-buttons">
              <a
                href={whatsappHref}
                className="btn-cta primary"
                target="_blank"
                rel="noopener noreferrer"
                aria-disabled={!whatsappHref}
              >
                <img src={whats} alt="WhatsApp" className="btn-cta-icon btn-cta-icon-whats" />
                Conversar pelo WhatsApp
              </a>
              <a
                href="https://www.instagram.com/acasadosgatos.lages/"
                className="btn-cta secondary"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={insta} alt="Instagram" className="btn-cta-icon" />
                Visite nosso Instagram
              </a>
            </div>
          </div>
        </div>

        <div className="contact-header">
          <p className="contact-subtitle">Estamos sempre prontos para cuidar do seu felino com muito amor e carinho!</p>
        </div>

        <div className="contact-grid">
          {/* Card de Horários */}
          <div className="contact-card schedule-card">
            <div className="card-header">
              <img src={abrir} alt="Horário de funcionamento" className="card-icon" />
              <h3>Horário de Funcionamento</h3>
            </div>
            <div className="schedule-list">
              <p>
                Nosso horário de atendimento pode variar conforme a demanda da loja física e da clínica para gatos.
              </p>
              <p>
                Para consultar os horários atualizados ou agendar uma visita clínica para o seu felino, entre em contato com nossa equipe pelo WhatsApp ou Instagram.
              </p>
              <p>
                Será um prazer cuidar do seu gatinho com todo carinho e atenção que ele merece!
              </p>
            </div>
          </div>
        </div>

        <div className="contact-grid">
          {/* Card do Mapa */}
          <div className="contact-card map-card">
            <div className="card-header">
              <img src={mapa} alt="Mapa de localização" className="card-icon" />
              <h3>Nossa Localização</h3>
            </div>
            <div className="map-wrapper">
              <iframe
                src="https://www.google.com/maps?q=Rua+Francisco+de+Paula+Ramos,+104,+Lages,+SC,+88523-020&output=embed"
                width="100%"
                height="300"
                style={{ border: 0, borderRadius: '15px' }}
                allowFullScreen={true}
                loading="lazy"
                title="Localização da A Casa dos Gatos - Rua Francisco de Paula Ramos, 104, Lages"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContatoPage;